import { useRouter } from "next/router";
import { useEffect } from "react";

export const useScrollHashTargetIntoView = () => {
  const router = useRouter();
  const asPath = router && router.asPath;
  const hashIx = asPath && asPath.indexOf("#");

  useEffect(() => {
    if (Number.isInteger(hashIx)) {
      const targetElId = asPath.slice(hashIx + 1);
      if (targetElId) {
        const targetNode = document.getElementById(targetElId);
        if (targetNode) {
          targetNode.scrollIntoView();
        }
      }
    }
  }, [hashIx, asPath]);
};
